export const checkScrollAtBottom = (containerDiv, scrollThreshold = 5) => {
  return (
    Math.abs(
      containerDiv.scrollHeight -
        containerDiv.scrollTop -
        containerDiv.clientHeight
    ) < scrollThreshold && containerDiv.scrollTop > 0
  );
};
